import { DialogProps, Drawer } from 'vaul'
import { Icon24 } from 'builder/components/Icon'
import Colors from 'builder/styles/colors'
import {
  Content,
  DrawerClose,
  DrawerHeader,
  DrawerParagraph,
  DrawerTitle,
  Footer,
  Overlay,
} from './styles'

type DrawerModalProps = Pick<DialogProps, 'open' | 'onClose'> & {
  title?: string
  description?: string
  footer?: React.ReactNode
  children?: React.ReactNode
  trigger?: React.ReactNode
}

export default function DrawerModal({
  open,
  onClose,
  title,
  description,
  footer,
  children,
  trigger,
}: DrawerModalProps) {
  return (
    <Drawer.Root open={open} onClose={onClose}>
      {trigger && <Drawer.Trigger asChild>{trigger}</Drawer.Trigger>}
      <Drawer.Portal>
        <Overlay />
        <Content>
          <DrawerClose>
            <Icon24.CloseIcon color={Colors.Neutral5} />
          </DrawerClose>
          {(title || description) && (
            <DrawerHeader>
              {title && <DrawerTitle>{title}</DrawerTitle>}
              {description && <DrawerParagraph>{description}</DrawerParagraph>}
            </DrawerHeader>
          )}
          {children}
          {footer && <Footer>{footer}</Footer>}
        </Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
